import logo from '@/assets/sobrussupplylogo.svg';
import unauthoriz from '@/assets/unauthoriz.png';

import React from 'react';
import { Link } from 'react-router';

import { Button } from '@sobrus-com/sobrus-design-system-v2';

import './sns__unauthorized.scss';

const ErrorPage: React.FC = () => {
	return (
		<div className="sns__error">
			<div className="part__2">
				<img style={{ display: 'block', width: 148 }} src={logo} alt="" />
				<p className="oops">Ooops !</p>
				<p>
					Votre compte semble être introuvable ou désactivé, si vous ignorez la raison de cette erreur vous
					pouvez contacter le service administratif de Sobrus
				</p>
				<Link to="/">
					<Button color="primary">Quitter</Button>
				</Link>
			</div>
			<div className="image">
				<img src={unauthoriz} alt="" />
			</div>
		</div>
	);
};

export default ErrorPage;
